import React, { useState } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const FormContainer = styled.div`
  width: 100%;
`;

const FormTitle = styled.h2`
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
`;

const FormDescription = styled.p`
  margin-bottom: 20px;
  color: #666;
  text-align: center;
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  
  &:focus {
    outline: none;
    border-color: #4285f4;
    box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.2);
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  background-color: #4285f4;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #3367d6;
  }
  
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.div`
  background-color: #ffebee;
  color: #c62828;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 20px;
  text-align: center;
`;

const SuccessMessage = styled.div`
  background-color: #e8f5e9;
  color: #2e7d32;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 20px;
  text-align: center;
`;

const XandrCredentialsForm = ({ onSaved }) => {
  const [credentials, setCredentials] = useState({
    xandrUsername: '',
    xandrPassword: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await axios.post('/api/auth/xandr-credentials', credentials);
      
      if (response.data.success) {
        setSuccess('Identifiants Xandr enregistrés avec succès');
        
        // Attendre un peu pour que l'utilisateur voie le message de succès
        setTimeout(() => {
          if (onSaved) {
            onSaved(); // Appeler la fonction de callback
          }
          navigate('/'); // Rediriger explicitement vers la page d'accueil
        }, 1500);
      } else {
        setError(response.data.message || 'Une erreur est survenue');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erreur lors de l\'enregistrement des identifiants');
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormContainer>
      <FormTitle>Configuration des identifiants Xandr</FormTitle>
      <FormDescription>
        Veuillez entrer vos identifiants Xandr pour accéder aux rapports.
        Ces informations seront stockées de manière sécurisée.
      </FormDescription>
      
      {error && <ErrorMessage>{error}</ErrorMessage>}
      {success && <SuccessMessage>{success}</SuccessMessage>}
      
      <form onSubmit={handleSubmit}>
        <FormGroup>
          <Label htmlFor="xandrUsername">Nom d'utilisateur Xandr</Label>
          <Input
            type="text"
            id="xandrUsername"
            name="xandrUsername"
            value={credentials.xandrUsername}
            onChange={handleChange}
            required
          />
        </FormGroup>
        
        <FormGroup>
          <Label htmlFor="xandrPassword">Mot de passe Xandr</Label>
          <Input
            type="password"
            id="xandrPassword"
            name="xandrPassword"
            value={credentials.xandrPassword}
            onChange={handleChange}
            required
          />
        </FormGroup>
        
        <SubmitButton 
          type="submit" 
          disabled={loading}
        >
          {loading ? 'Enregistrement...' : 'Enregistrer'}
        </SubmitButton>
      </form>
    </FormContainer>
  );
};

export default XandrCredentialsForm;
